import React, { useEffect, useState } from 'react'
import './HeaderStyle.css'
import { useNavigate } from 'react-router-dom';
import NotificationDropDown from '../../components/Popups/NotificationDropDown/NotificationDropDown'
import ProfileDropDown from '../../components/Popups/ProfileDropDown/ProfileDropDown'

function Header({ onClickMenu, setOnClickMenu }) {
  
  const role = localStorage.getItem("role");

  const [isOpenMeg, setIsOpenMeg] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  const navigate = useNavigate();

  const setWindowDimensions = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', setWindowDimensions);
    return () => {
      window.removeEventListener('resize', setWindowDimensions)
    }
  }, [])

  return (
    <>
      <header className='Header'>
        <div className="headerWrapper flex-between">
          {windowWidth >= 767 ? <h2>Welcome <span> {role === "4419ab4b-bae0-4426-a4d0-1d2e5f3b60d1" ? 'Admin' : localStorage.getItem('name')} ! </span></h2> : <img src={"/assets/svg/Logo.svg"} alt="" className='pointer' onClick={() => { navigate('/') }} />}
          <div className="rightheader">
            {windowWidth >= 767 ?
              <>

                {/* <div className="NotificationIcon flex-center active ">
                  <img src="/assets/img/notification.png" alt="" className='notification1 pointer' onClick={() => { setIsOpenMeg(!isOpenMeg); setIsOpen(false) }} />
                  <NotificationDropDown isActive={isOpenMeg} setIsActive={setIsOpenMeg} />
                </div> */}
                <div onClick={() => { setIsOpen(!isOpen); setIsOpenMeg(false); }}>
                  <img src={(localStorage.getItem("profileImg") !== "null" && localStorage.getItem("profileImg") !== "undefined" && localStorage.getItem("profileImg")) ? localStorage.getItem("profileImg") : "/assets/img/User.png"} className='headerPimg pointer' alt='' />
                  <ProfileDropDown isActive={isOpen} setIsActive={setIsOpen} />
                </div>
              </>
              : <button className={`hamButton ${onClickMenu === true ? 'active' : ''}`} onClick={() => setOnClickMenu(!onClickMenu)}>
                <span className="hamLines"></span>
                <span className="hamLines"></span>
                <span className="hamLines"></span>
              </button>
            }
          </div>
        </div>
      </header>
    </>
  )
}

export default Header